module.exports = __webpack_public_path__ + "img/warning-sign.26f66859.svg";